import { FormControlLabel, Switch as MuiSwitch } from '@mui/material';
import s from './Switch.module.scss';

type SwitchProps = {
  label: string;
  value: boolean;
  setValue?: (value: boolean) => void;
};
export const Switch = ({ label, value, setValue }: SwitchProps) => {
  const onSelect = (_: any, newValue: boolean) => {
    if (setValue) setValue(newValue);
  };

  return (
    <FormControlLabel
      label={<span className={s.switch__label}>{label}</span>}
      control={
        <MuiSwitch color="default" checked={value} onChange={onSelect} />
      }
    />
  );
};
